// extracted by mini-css-extract-plugin
export default {"modal":"NotPermissionModal_modal__gle59","content":"NotPermissionModal_content__f8msq","text":"NotPermissionModal_text__SB-ZY"};